module.exports = __webpack_public_path__ + "img/oredoo.927c7253.svg";